export default class CharConfig {
  constructor() {
    this.maintainAspectRatio = false
    this.responsive = true
    this.title = {
      display: false,
      position: 'top',
      fontFamily: 'DroidSans',
    }
    this.hover = {
      mode: null,
      intersect: false,
    }
    this.legend = {
      onClick: null,
      display: false,
      fontFamily: 'DroidSans',
    }
    this.tooltips = {
      enabled: false,
    }
    this.scales = {
      xAxes: [{
        display: false,
      }],
      yAxes: [{
        display: false,
      }],
    }
  }

  showTitle(text) {
    this.title.display = true
    this.title.text = text
  }

  showLegend() {
    this.legend.display = true
  }
}



// WEBPACK FOOTER //
// ./components/chart/chartConfig.js